import { Outlet, Link, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import logoSvg from '../assets/logo.svg'
import SkipLink from '../components/shared/SkipLink'

export default function MarketingLayout() {
  const location = useLocation()
  const { user } = useAuth()

  // Hide nav on login/verify pages for cleaner experience
  const isAuthPage = location.pathname === '/login' || location.pathname === '/verify'

  return (
    <>
      {/* Skip Link for keyboard users */}
      <SkipLink href="#main-content" />

      {/* Navigation */}
      {!isAuthPage && (
        <nav className="nav" aria-label="Main navigation">
          <div className="container nav-inner">
            <Link to="/" aria-label="PlanScan home">
              <img src={logoSvg} alt="PlanScan" className="nav-logo" />
            </Link>
            <ul className="nav-links" role="list">
              <li><Link to="/#features" className="nav-link">Features</Link></li>
              <li><Link to="/pricing" className="nav-link">Pricing</Link></li>
              <li><Link to="/download" className="nav-link">Download</Link></li>
              <li>
                {user ? (
                  <Link to="/dashboard" className="btn btn-primary">Dashboard</Link>
                ) : (
                  <Link to="/login" className="btn btn-primary">Sign In</Link>
                )}
              </li>
            </ul>
          </div>
        </nav>
      )}

      {/* Page Content */}
      <main id="main-content" tabIndex={-1}>
        <Outlet />
      </main>

      {/* Footer */}
      {!isAuthPage && (
        <footer className="footer" role="contentinfo">
          <div className="container">
            <img src={logoSvg} alt="PlanScan" className="footer-logo" />
            <ul className="footer-links" role="list">
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="footer-link">Terms of Use</Link></li>
              <li><Link to="/faq" className="footer-link">FAQ</Link></li>
              <li><a href="mailto:support@planscan.io" className="footer-link">Contact</a></li>
            </ul>
            <p className="footer-copy">
              &copy; {new Date().getFullYear()} PlanScan. All rights reserved.
            </p>
          </div>
        </footer>
      )}
    </>
  )
}
